// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__-InZ8"};